import { useState } from 'react';
import {
	useOpen,
} from '@aleph/shared-components';

export type SetShowConfirmActionDialog = React.Dispatch<React.SetStateAction<boolean>>;

export interface RenderConfirmActionDialogProps {
	onConfirm: () => void
	onClose: () => void
}

export interface IProps {
	onConfirm: () => void
	defaultShouldPromptOnClose?: boolean
	DialogComponent: React.ComponentType<RenderConfirmActionDialogProps>
}

export default function useConfirmActionDialog({
	onConfirm,
	defaultShouldPromptOnClose = false,
	DialogComponent,
}: IProps) {
	const [shouldPromptOnClose, setShouldPromptOnClose] = useState(defaultShouldPromptOnClose);
	const [isOpen, { onOpen, onClose }] = useOpen(false);

	function beforeClose() {
		if (shouldPromptOnClose) {
			onOpen();
		} else {
			onConfirm();
		}
	}

	return {
		shouldPromptOnClose,
		dialog: (
			isOpen
				? (
					<DialogComponent
						onConfirm={() => {
							onConfirm();
							onClose();
						}}
						onClose={onClose}
					/>
				)
				: null
		),
		beforeClose,
		setShouldPromptOnClose,
	};
}
